import Script from 'next/script'

interface BaseSchemaProps {
  pageUrl?: string
  pageTitle?: string
  additionalSchema?: object[]
}

export default function BaseSchema({ 
  pageUrl = 'https://rentwise.co', 
  pageTitle = 'RentWise',
  additionalSchema = []
}: BaseSchemaProps) {
  const baseSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://rentwise.co/#website",
        "url": "https://rentwise.co",
        "name": "RentWise",
        "description": "Find your perfect home with verified reviews from real tenants",
        "publisher": {
          "@id": "https://rentwise.co/#organization"
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://rentwise.co/browse?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "Organization",
        "@id": "https://rentwise.co/#organization",
        "name": "RentWise",
        "url": "https://rentwise.co",
        "logo": {
          "@type": "ImageObject",
          "url": "https://rentwise.co/images/logo-wordmark.png",
          "@id": "https://rentwise.co/#logo"
        },
        "sameAs": [
          "https://www.linkedin.com/company/tryRentWise",
          "https://x.com/tryRentWise",
          "https://www.facebook.com/tryRentWise",
          "https://www.instagram.com/tryRentWise",
          "https://github.com/rentwise"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer support",
          "availableLanguage": ["English"],
          "serviceArea": {
            "@type": "Country",
            "name": "Nigeria"
          }
        },
        "knowsAbout": [
          "Property Reviews",
          "Rental Properties",
          "Property Sales",
          "Landlord Reviews", 
          "Tenant Reviews",
          "Real Estate",
          "Property Management"
        ],
        "areaServed": {
          "@type": "Country",
          "name": "Nigeria"
        },
        "foundingDate": "2025",
        "slogan": "Find your perfect home with verified reviews from real tenants",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Property Review Services",
          "itemListElement": [
            {
              "@type": "Service",
              "name": "Property Review Platform",
              "description": "Verified reviews from real tenants"
            },
            {
              "@type": "Service", 
              "name": "Property Listings",
              "description": "Properties for rent and sale"
            }
          ]
        }
      },
      ...additionalSchema
    ]
  }

  return (
    <Script
      id="base-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(baseSchema)
      }}
    />
  )
} 